import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "tooltipTitle"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorButton = _ref => {
  let {
      children,
      tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "error.buttonTooltip"
      })
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltipTitle,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      disabled: true
    }, buttonProps, {
      children: children
    }))
  });
};
export default ErrorButton;